export default "__VITE_PUBLIC_ASSET__f827af1b__"